import { Stack, Divider, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAuth } from 'context/AuthContext';
import BellIcon from 'icons/BellIcon';
import MailIcon from 'icons/MailIcon';
import { useNavigate } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';

export default function SidebarHeader({ mini }: { mini: boolean }) {
  const { doctor } = useAuth();
  const navigate = useNavigate();
  const globalStyles = useGlobalStyles();

  return (
    <Stack spacing={0.5} sx={{ px: 1 }}>
      <Divider sx={{ my: 1 }} />

      {!doctor && <ListItemButton
        onClick={() => navigate('/notifications')}
        className={globalStyles.sidebarIconButton}
        sx={{ justifyContent: 'center' }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            justifyContent: 'center',
          }}
        >
          <BellIcon />
        </ListItemIcon>
        {!mini && <ListItemText primary="Notifications" sx={{ ml: 2 }} />}
      </ListItemButton>}

      <ListItemButton
        onClick={() => navigate('/contact')}
        className={globalStyles.sidebarIconButton}
        sx={{ justifyContent: 'center' }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            justifyContent: 'center',
          }}
        >
          <MailIcon />
        </ListItemIcon>
        {!mini && <ListItemText primary="Contact Us" sx={{ ml: 2 }}/>}
      </ListItemButton>
    </Stack>
  );
}
